export const removeCityFromLocation = (location: string): string => {
    const splitLocationOrigin = location.split('.');
    splitLocationOrigin.shift();
    return splitLocationOrigin.join('.');
};
